import Vue from "vue";
import VueI18n from "vue-i18n";

import es from "element-ui/lib/locale/lang/es";
import en from "element-ui/lib/locale/lang/en";

// const elementUILocales = {
//   es,
//   en,
// };

import esApp from "@/locales/es.json";
let enApp = {};

Vue.use(VueI18n);

function deepMerge(target, source) {
  if (typeof target !== "object" || target === null) return source;
  if (typeof source !== "object" || source === null) return target;
  const out = Array.isArray(target) ? target.slice() : { ...target };
  for (const key of Object.keys(source)) {
    const sv = source[key];
    const tv = out[key];
    if (Array.isArray(sv)) {
      out[key] = sv.slice();
    } else if (typeof sv === "object" && sv !== null) {
      out[key] = deepMerge(typeof tv === "object" && tv !== null ? tv : {}, sv);
    } else {
      out[key] = sv;
    }
  }
  return out;
}

const baseMessages = {
  es: deepMerge(esApp || {}, es || {}),
  en: deepMerge(enApp || {}, en || {}),
};

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "es",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: baseMessages,
});

export default i18n;
